/**
 * handles all anchors url #hashtags
 */

(function($, window) {
	if (window.naluTocScroll) return
	window.naluTocScroll = function(target) {
		if (!target) return;

		// offset
		let offset = 10

		// offset navbar height
		let navBar = $('.navbar.primary');
		offset += navBar.length > 0 && navBar.css('position') === 'fixed' ? navBar.first().outerHeight() : 0

		// offset admin bar height
		let adminBar = $('#wpadminbar');
		offset += adminBar.length > 0 ? adminBar.first().outerHeight() : 0

		// smooth scroll
		$('html, body').animate({scrollTop: target.offset().top - offset}, 1000, function() {
			// Callback after animation
			// Must change focus!
			var $target = $(target);
			$target.focus();
			if ($target.is(":focus")) { // Checking if the target was focused
				return false;
			}
			else {
				$target.attr('tabindex', '-1'); // Adding tabindex for elements not focusable
				$target.focus(); // Set focus again
			}
		});
	}


	$(document).ready(function() {

		//document.addEventListener("DOMContentLoaded", function() {

		// scroll to hash on page load
		setTimeout(function() {
			if (location.hash) {
				// we need to scroll to the top of the window first, because the browser will always jump to the anchor
				// first before JavaScript is ready, thanks Stack Overflow: http://stackoverflow.com/a/3659116
				window.scrollTo(0, 0);

				let target = $('#' + location.hash.split('#')[1]);

				// if id exists the use it otherwise get [name] attribute
				target = target.length ? target : $('[name=' + location.hash.slice(1) + ']');

				naluTocScroll(target);
			}
		}, 1);


		// scroll a tags
		// taken from: https://css-tricks.com/snippets/jquery/smooth-scrolling/
		$('a[href*="#"]')//.not('[href="#"]').not('[href="#0"]')
		// Remove links that don't actually link to anything
				.not('[href="#"]')
				.not('[href="#0"]')
				.click(function(event) {
					// On-page links
					if (location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') &&
							location.hostname === this.hostname) {
						// Figure out element to scroll to
						let target = $(this.hash)
						target     = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
						// Does a scroll target exist?
						if (target.length) {
							// Only prevent default if animation is actually gonna happen
							event.preventDefault();
							// push history to url browser and url bar for bookmarking
							history.pushState(null, null, this.hash)
							naluTocScroll(target);
						}
					}
				});
	})


})(jQuery, window);
